export enum ClareStatuses {
    Online = "Online",
    Offline = "Offline",
    Unconfigured = "Unconfigured",
    Loading = "Loading",
    Enabled = "Enabled",
    Disabled = "Disabled",
    Inactive = "Inactive",
    Active = "Active",
    Unknown = "Unknown",
    ComingSoon = "Coming Soon",
    Idle = "Idle",
    Yes = "Yes",
    NotUpgraded = "Not Upgraded",
    Occupied = "Occupied",
    Vacant = "Vacant",
    True = "True",
    False = "False",
    Connected = "Connected",
    HighPriority = "High priority",
    MedLowPriority = "Medium-Low priority",
    NotConfigured = "Not Configured",
}

export enum ClareStatusColors {
    Online = "#219653",
    Offline = "#ef0a00",
    Unconfigured = "#a3a3a3",
    Loading = "#a3a3a3",
    SecurityReady = "#3a704d",
    SecurityFaulted = "#a7aa05",
    SecurityArmedStay = "#aa7a05",
    SecurityArmedAway = "#ef0a00",
    Active = "#3a704d",
    Suspended = "#aa7a05",
    Yes = "#219653",
    NotUpgraded = "#ef0a00",
    Interactive = "#3193B5",
    ProjectOnline = "#219653",
    Occupied = "#3193b5",
    Enabled = "#0091ea",
    True = "#0091ea",
    Connected = "#219653",
    HighPriority = "#EB0008",
    MedLowPriority = "#F1BA13",
}
export enum ConnectionTypes {
    Offline = "Offline",
    LteConnection = "LTE",
    EthConnection = "Ethernet",
    WifiConnection = "WiFi",
    Unknown = "Unknown",
}

export const onlineClareStatus: ClareStatus = [ClareStatuses.Online, ClareStatusColors.Online];
export const onlineProjectClareStatus: ClareStatus = [ClareStatuses.Online, ClareStatusColors.ProjectOnline];
export const offlineClareStatus: ClareStatus = [ClareStatuses.Offline, ClareStatusColors.Offline];
export const unconfiguredClareStatus: ClareStatus = [ClareStatuses.Unconfigured, ClareStatusColors.Unconfigured];
export const loadingClareStatus: ClareStatus = [ClareStatuses.Loading, ClareStatusColors.Loading];
export const enabledClareStatus: ClareStatus = [ClareStatuses.Enabled, ClareStatusColors.Enabled];
export const disabledClareStatus: ClareStatus = [ClareStatuses.Disabled, ClareStatusColors.Offline];
export const inactiveClareStatus: ClareStatus = [ClareStatuses.Inactive, ClareStatusColors.Offline];
export const activeClareStatus: ClareStatus = [ClareStatuses.Active, ClareStatusColors.Active];
export const unknownClareStatus: ClareStatus = [ClareStatuses.Unknown, ClareStatusColors.Unconfigured];
export const comingSoonClareStatus: ClareStatus = [ClareStatuses.ComingSoon, ClareStatusColors.Unconfigured];
export const idleClareStatus: ClareStatus = [ClareStatuses.Idle, ClareStatusColors.Unconfigured];
export const yesClareStatus: ClareStatus = [ClareStatuses.Yes, ClareStatusColors.Yes];
export const notUpgradedClareStatus: ClareStatus = [ClareStatuses.NotUpgraded, ClareStatusColors.NotUpgraded];
export const trueStatus: ClareStatus = [ClareStatuses.True, ClareStatusColors.True];
export const falseStatus: ClareStatus = [ClareStatuses.False, ClareStatusColors.Offline];
export const notConfiguredClareStatus: ClareStatus = [ClareStatuses.NotConfigured, ClareStatusColors.Unconfigured];

export const occupiedStatus: ClareStatus = [ClareStatuses.Occupied, ClareStatusColors.Occupied];
export const vacantStatus: ClareStatus = [ClareStatuses.Vacant, ClareStatusColors.Offline];

export const connectedClareStatus: ClareStatus = [ClareStatuses.Connected, ClareStatusColors.Connected];
export const highPriorityStatus = [ClareStatuses.HighPriority, ClareStatusColors.HighPriority];
export const medLowPriorityStatus = [ClareStatuses.MedLowPriority, ClareStatusColors.MedLowPriority];

export type ClareStatus = [ClareStatuses, ClareStatusColors];
export type ConnectionType = [ConnectionTypes];
export const GetConnectionType = (connection: string) => {
    if (connection === "Not Connected") {
        return "";
    }
    if (connection === "LTE" || connection === "CELLULAR") {
        return ConnectionTypes.LteConnection;
    }
    if (connection === "ETH") {
        return ConnectionTypes.EthConnection;
    }
    if (connection === "WIFI") {
        return ConnectionTypes.WifiConnection;
    }
    return ConnectionTypes.Unknown;
};
export const isProjectConnOnline = (connectionObj: any, uuid: string) => !!connectionObj[uuid];
